/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountdisablederror2Inputs */

const en_accountdisablederror2 = /** @type {(inputs: Accountdisablederror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This account has been disabled.`)
};

const de_accountdisablederror2 = /** @type {(inputs: Accountdisablederror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Konto wurde deaktiviert.`)
};

/**
* | output |
* | --- |
* | "This account has been disabled." |
*
* @param {Accountdisablederror2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const accountdisablederror2 = /** @type {((inputs?: Accountdisablederror2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountdisablederror2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_accountdisablederror2(inputs)
	return de_accountdisablederror2(inputs)
});
export { accountdisablederror2 as "accountDisabledError" }